import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-light booking-section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-header booking-section-header" }, "Others", -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "col-md-6"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import BookingNotes from "@/components/diary/BookingNotes.vue";
import { Booking } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'Others',
  emits: ['showinternalnotesdocument', 'showpinotesDocument'],
  setup(__props, { emit: __emit }) {

const store = useStore();
const booking = computed((): Booking => store.getters['diary/booking']);
const emit = __emit
const showInternalnotesDocument = (index:number) => {
  emit("showinternalnotesdocument",index);
}
const showpinotesDocument = (index:number) => {
  emit("showpinotesDocument",index);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(BookingNotes, {
            field: 'pinotes',
            documents: booking.value.pinotesdocuments,
            documentsfield: 'pinotesdocuments',
            onShowdocument: showpinotesDocument
          }, null, 8, ["documents"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BookingNotes, {
            field: 'internalnotes',
            documents: booking.value.internalnotesdocuments,
            documentsfield: 'internalnotesdocuments',
            onShowdocument: showInternalnotesDocument
          }, null, 8, ["documents"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BookingNotes, {
            field: 'titlenotes',
            fixedsize: true
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BookingNotes, { field: 'longtermnotes' })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (booking.value.cancelled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(BookingNotes, { field: 'cancelnotes' })
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})